import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    marginBottom: 15,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  text: {
    display: 'block',
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
  icons: {
    marginBottom: 15,
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));
